import { Instagram, Facebook, Mail, Heart } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="bg-[#2C2A28] text-[#FDFBF9] py-20 lg:py-32" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* CTA Section */}
        <div className="text-center mb-16">
          <p className="overline text-[#C8A99C] mb-4">Ready to create magic?</p>
          <h2 className="font-heading text-4xl lg:text-6xl font-light tracking-tight mb-8">
            Let's Talk
          </h2>
          <button
            onClick={() => scrollToSection("#booking")}
            className="px-10 py-4 bg-[#FDFBF9] text-[#2C2A28] font-body text-sm tracking-wide hover:bg-[#E2CCC2] transition-all duration-300"
            data-testid="footer-cta-button"
          >
            Book Your Session
          </button>
        </div>

        {/* Divider */}
        <div className="w-full h-px bg-[#5C5A56]/30 mb-12" />

        {/* Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <h3 className="font-heading text-2xl mb-4">Brittany Bailey</h3>
            <p className="font-body text-[#A8B5A3] text-sm leading-relaxed mb-6">
              Award-winning photographer in Breaux Bridge & Lafayette, Louisiana. Specializing in weddings, seniors, families, and everything in between.
            </p>
            <div className="flex gap-4">
              <a
                href="https://instagram.com/brittbaileyphoto"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 border border-[#5C5A56]/30 flex items-center justify-center text-[#FDFBF9] hover:bg-[#C8A99C] hover:border-[#C8A99C] transition-all"
                data-testid="footer-instagram"
              >
                <Instagram size={18} />
              </a>
              <a
                href="https://facebook.com/brittbaileyphoto"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 border border-[#5C5A56]/30 flex items-center justify-center text-[#FDFBF9] hover:bg-[#C8A99C] hover:border-[#C8A99C] transition-all"
                data-testid="footer-facebook"
              >
                <Facebook size={18} />
              </a>
              <a
                href="mailto:hello@brittbaileyphoto.com"
                className="w-10 h-10 border border-[#5C5A56]/30 flex items-center justify-center text-[#FDFBF9] hover:bg-[#C8A99C] hover:border-[#C8A99C] transition-all"
                data-testid="footer-email"
              >
                <Mail size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-body text-sm uppercase tracking-widest mb-6 text-[#C8A99C]">
              Quick Links
            </h4>
            <nav className="space-y-3">
              {[
                { href: "#about", label: "About" },
                { href: "#portfolio", label: "Portfolio" },
                { href: "#services", label: "Services" },
                { href: "#testimonials", label: "Kind Words" },
                { href: "#contact", label: "Contact" },
                { href: "#booking", label: "Book Now" },
              ].map((link) => (
                <button
                  key={link.href}
                  onClick={() => scrollToSection(link.href)}
                  className="block font-body text-sm text-[#A8B5A3] hover:text-[#FDFBF9] transition-colors"
                  data-testid={`footer-link-${link.label.toLowerCase().replace(" ", "-")}`}
                >
                  {link.label}
                </button>
              ))}
            </nav>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-body text-sm uppercase tracking-widest mb-6 text-[#C8A99C]">
              Get In Touch
            </h4>
            <div className="space-y-4 font-body text-sm">
              <p className="text-[#A8B5A3]">
                Breaux Bridge & Lafayette, Louisiana
              </p>
              <a
                href="mailto:hello@brittbaileyphoto.com"
                className="block text-[#A8B5A3] hover:text-[#FDFBF9] transition-colors"
              >
                hello@brittbaileyphoto.com
              </a>
              <a
                href="https://instagram.com/brittbaileyphoto"
                target="_blank"
                rel="noopener noreferrer"
                className="block text-[#A8B5A3] hover:text-[#FDFBF9] transition-colors"
              >
                @brittbaileyphoto
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-16 pt-8 border-t border-[#5C5A56]/30 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="font-body text-xs text-[#5C5A56]">
            © {currentYear} Brittany Bailey Photography. All rights reserved.
          </p>
          <p className="font-body text-xs text-[#5C5A56] flex items-center gap-1">
            Made with <Heart size={12} className="text-[#C8A99C]" /> in Louisiana
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
